<template>
  <div 
  class="player-card"
  :class="{
    'your-character': user.uid == member.user
  }">
    <div class="notification is-info">
      <div class="player-line">
        <div class="player-name has-text-weight-semibold">{{ member.name }}</div>
        <div v-show="member.initiative !== null" class="player-init">
          <span class="icon is-medium">
            <i class="fas fa-dice-d20 fa-sm"></i>
          </span>
          <span class="has-text-weight-semibold">{{ member.initiative }}</span>
        </div>
      </div>
      <Conditions 
      :campaignId="campaignId" 
      collection="party" 
      :id="member.id"/>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Conditions from '../components/Conditions.vue'

export default {
  name: 'PlayerCard',
  props: {
    campaignId: String,
    member: Object,
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
  },
  components: {
    Conditions,
  }
}
</script>
<style scoped>
/* @media (max-width: 900px) and (orientation: landscape) {
  .player-card:not(.your-character) {
    display: none;
  }
} */
.player-card {
  position: relative;
  margin-left: -32px;
}
.notification {
  /* background: rgba(0, 102, 204, 0.418);
  border: 4px solid #0066CC; */
  border-radius: 10px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0;
}
.player-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  font-size: 1.25em;
}
.player-line:not(:last-child) {
  margin-bottom: 0.25em;
}
@media screen and (min-width: 769px) {
  .player-line {
    font-size: 1.4em;
  }
}
.player-init {
  margin-left: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/PlayerCard.vue